import { render, staticRenderFns } from "./TrainingTopicList.vue?vue&type=template&id=8ff8ca50"
import script from "./TrainingTopicList.vue?vue&type=script&lang=js"
export * from "./TrainingTopicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports